import React from "react";
import Button from "web/components/Button";
import DeleteIcon from "web/assets/images/delete-icon.webp";
import AddIcon from "web/assets/images/plus-icon.webp";
import CloseIcon from "web/assets/images/CloseIcon.png";
import AddSubAccount from "web/components/AddSubAccount";
import Tooltip from "@material-ui/core/Tooltip";

import {
  Wrapper,
  DetailSection,
  CloseBtn,
  Location,
  LocationDetails,
  Usertable,
} from "web/pages/account/account-settings/manage-accounts/manageAccountstyled";

const LocationUsers = ({
  toggleDisplayPage,
  activeUser,
  currentLocationData,
  currentLocationIndex,
  pageLanguageContents,
  locationData,
  apiResponse,
  onChangeHandler,
  editPurchasingToggleModal,
  clickHandler,
  reinviteUser,
  description,
}) => {
  let brokerAccount = localStorage.getItem("brokerAccount");
  if (!currentLocationIndex) {
    currentLocationIndex = 0
  }
  return (
    <Wrapper>
      <div className="manage-location-header">
        <h4 style={{ marginBottom: "0" }}>
          {brokerAccount === "brokerAc"
            ? pageLanguageContents?.Location_Contents[27]?.Title_Broker
            : pageLanguageContents?.Location_Contents[0]?.Title}

        </h4>
        {activeUser !== "SubAccount" && (
          <CloseBtn>
            <Button
              handleClick={() => {
                toggleDisplayPage();
              }}
            >
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
          </CloseBtn>
        )}
        <div className="web-view">
        <p style={{ textAlign: "justify", color: "#0a5587" }}>{description}</p>

        </div>
      </div>
      <div className="mobile-view box-shadow">
      <p style={{ textAlign: "justify", color: "#0a5587" }}>{description}</p>

        </div>
      <DetailSection>
        {apiResponse.userDetail &&
          apiResponse.userDetail.name &&
          apiResponse.userDetail.account && apiResponse.listCorporateLocations[currentLocationIndex].locationType !== "MAIN" && (
            <div className="company-detail">
              {apiResponse.userDetail.registerDTO && (
                <>
                  <h3>
                    {apiResponse.userDetail.registerDTO.basicDetail.companyName}
                  </h3>
                  <h4>{`${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.line1}`}</h4>
                  <h4>{`${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.city} ${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.state} ${apiResponse.userDetail.registerDTO.basicDetail.registeredAddress.zip}`}</h4>
                </>
              )}
            </div>
          )}
      </DetailSection>
      <Location>
        <div className="add-location">
          <h3>Location</h3>
        </div>
      </Location>
      <LocationDetails>
        <div>
          <Tooltip
            placement="top"
            arrow
            title={currentLocationData.locationName}            
            enterTouchDelay={5}
            leaveTouchDelay={10000}
          >
            <h3>{currentLocationData.locationName}</h3>
          </Tooltip>
          <div style={{ display: "block" }}>
            {currentLocationData.address && (
              <>
                <p>{`${currentLocationData.address.line1}`}</p>
                <p>{`${currentLocationData.address.city} ${currentLocationData.address.state} ${currentLocationData.address.zip}`}</p>
              </>
            )}
          </div>
        </div>

        {(currentLocationData.purchasingLimit ||
          currentLocationData.purchasingLimit === 0) && (
            <>
              <div>
                <div>
                  <h3>
                    {`$ ${
                      currentLocationData.purchasingLimit
                        ? currentLocationData.purchasingLimit
                        : 0
                      }`}
                    {currentLocationData.corporateSubAccounts &&
                      currentLocationData.corporateSubAccounts.map(
                        (data, index) => (
                          <>
                            {apiResponse.userDetail.accountType ===
                              "CORPORATE_ADMIN" &&
                              currentLocationData.locationType !== "MAIN" && (
                                <a
                                  className="icon-btn"
                                  onClick={() => {
                                    editPurchasingToggleModal(
                                      currentLocationData.id,
                                      currentLocationData.purchasingLimit
                                    );
                                  }}
                                >
                                </a>
                              )}
                          </>
                        )
                      )}
                  </h3>
                </div>
                <p>Total Purchasing Limit</p>
              </div>

            </>
          )}
      </LocationDetails>

      <Usertable>
        <div className="table-header">
          <p>Users</p>
          {(apiResponse.userDetail.accountType === "INDIVIDUAL" ||
            apiResponse.userDetail.accountType === "CORPORATE_ADMIN") && (<>
              {currentLocationData?.isActive && <div>
                <AddSubAccount
                  pageLanguageContents={pageLanguageContents}
                  buttonName={
                    <>
                      <img src={AddIcon} alt="add-icon" />
                      Add User
                  </>
                  }
                  locationList={locationData}
                  index={currentLocationIndex}
                  onChangeHandler={onChangeHandler}
                />
              </div>}              
             </>
            )}
        </div>
        <div className="table-body">
          {currentLocationData.corporateSubAccounts &&
            currentLocationData.corporateSubAccounts.map((data, index) => {
              return (
                <div className="table-row">
                  <div>
                    <Tooltip
                      placement="top"
                      enterTouchDelay={0}                      
                      leaveTouchDelay={10000}
                      arrow
                      title={`${data.name} (${data.email})`}
                    >
                      {data.isAdminAccount ? (
                        <span className="user-email-id">{`${data.name} (${data.email}) -Admin`}</span>
                      ) : (
                          <span className="user-email-id">{`${data.name} (${data.email}) -User`}</span>
                        )}
                    </Tooltip>
                  </div>
                  {(apiResponse.userDetail.accountType === "INDIVIDUAL" ||
                    apiResponse.userDetail.accountType ===
                    "CORPORATE_ADMIN") && (
                      <div className="action-btn">
                        {data.status === "Invited" && currentLocationData?.isActive && (
                          <Button
                            type="app-green-button active"
                            handleClick={() => reinviteUser(data)}
                          >
                            Reinvite
                        </Button>
                        )}
                
                        {data.status === "Inactive" && currentLocationData?.isActive && (
                          <Button
                            type="app-green-button active"
                            disabled={data.isAdminAccount ? true : false}
                            handleClick={() =>
                              clickHandler(
                                currentLocationData.locationName,
                                data,
                                "Active"
                              )
                            }
                          >
                            Activate
                        </Button>
                        )}
                        {(data.status === "Active" || data.status === "ACTIVE") && currentLocationData?.isActive && (
                          <Button
                            type="app-green-button active "
                            disabled={data.isAdminAccount ? true : false}
                            handleClick={() =>
                              clickHandler(
                                currentLocationData.locationName,
                                data,
                                "Inactive"
                              )
                            }
                          >
                            Deactivate
                        </Button>
                        )}
                        {currentLocationData?.isActive && <div>
                          <Button
                            type="app-green-button active"
                            disabled={data.isAdminAccount ? true : false}
                            handleClick={() =>
                              clickHandler(
                                currentLocationData.locationName,
                                data,
                                "Delete"
                              )
                            }
                          >
                            <img src={DeleteIcon} alt="delete-icon" />
                            Delete
                        </Button>
                        </div>}
                      </div>
                    )}
                </div>
              );
            })}
        </div>
      </Usertable>
    </Wrapper>
  );
};

export default LocationUsers;
